export enum SystemUserGroup {
  SUPPORT = "msend-application-support",
}
